export default "__VITE_ASSET__ByrET3WI__"